import { getApiKey } from "../../utils/apiKey";
import React, { Component } from "react";
import { apiCall_domain } from "../api";
import Header from "../header";
import { createGlobalStyle } from "styled-components";
import axios from "axios";
import Spinner from "../Spinner/Spinner";
import { Link } from "react-router-dom";

class kacharSupport extends Component {
  state = {
    VendorHeader: true,
    tickets: [],
    loading: true,
  };
  componentDidMount() {
    const Headers = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };

    axios
      .get(`${apiCall_domain}/customer/user/tickets`, {
        headers: Headers,
      })
      .then((res) => {
        this.setState({ tickets: res.data.data, loading: false });
      });
  }
  TicketDetails(id) {
    this.props.history.push("/showMore/Support/TicketDetails");
    localStorage.setItem("ticketDetailsIdUser", id);
  }
  render() {
    const GlobalStyles = createGlobalStyle`body{
            background: #F9F9F9;
          }`;
    return (
      <>
        {this.state.loading ? (
          <Spinner />
        ) : (
          <>
            <GlobalStyles />
            <Header
              showSearchBar={true}
              title={"پشتیبانی"}
              VendorHeader={this.state.VendorHeader}
            />
            <div className="GuideSopportCom">
              <div className="top">
                <div className="img">
                  <img src="/public/assets/icons/44.png" alt="pic" />
                </div>
                <div className="btn">راهنما</div>
              </div>
              {this.state.tickets.length === 0 ? (
                <div className="bottom">
                  <div className="img">
                    <img src="/public/assets/icons/sms.svg" alt="pic" />
                    <span>موردی برای نمایش وجود ندارد</span>
                  </div>
                </div>
              ) : (
                this.state.tickets.map((Item) => (
                  <div
                    className="TicketMainDiv"
                    onClick={() => this.TicketDetails(Item.id)}
                  >
                    <div className="right">
                      <div className="img">
                        <img
                          src="/public/assets/icons/messageTicket.svg"
                          alt="pic"
                        />
                      </div>
                      <div className="TitlTicket">
                        <div className="TtileTicketInner">{Item.title}</div>
                        <div className="textTicket">
                          {Item.last_message?.text}
                        </div>
                      </div>
                    </div>
                    <div className="left">
                      <div className="Time">{Item.last_ts}</div>
                    </div>
                  </div>
                ))
              )}
            </div>
            <Link to={"/ticket"}>
              <div className="CertificateInnerComAddBTN">
                <img src="/public/assets/icons/add4.svg" alt="pic" />
              </div>
            </Link>
          </>
        )}
      </>
    );
  }
}
export default kacharSupport;
